module.exports = __webpack_public_path__ + "img/comm_welbeing.74196440.svg";